import { CdkDrag, CdkDragDrop, CdkDragHandle, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, inject, OnInit, signal, ViewEncapsulation } from '@angular/core';
import { CapturumButtonModule } from '@capturum/ui/button';
import { NodeDataParameters } from '@features/flow-ui-creator/interfaces/node.interface';
import { FlowService } from '@features/flow-ui-creator/services/flow.service';
import { FieldArrayType, FormlyModule } from '@ngx-formly/core';
import { TranslateModule } from '@ngx-translate/core';
import { DisabledByPropertyPipe } from '../pipes/disabled-by-property.pipe';

@Component({
  selector: 'app-formly-node-if-condition-repeat',
  imports: [
    FormlyModule,
    CapturumButtonModule,
    TranslateModule,
    CdkDrag,
    CdkDragHandle,
    CdkDropList,
    DisabledByPropertyPipe,
  ],
  templateUrl: './formly-node-if-condition-repeat.component.html',
  styleUrl: './formly-node-if-condition-repeat.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class FormlyNodeIfConditionRepeatComponent extends FieldArrayType implements OnInit {
  containerStyles = signal<{ [key: string]: any }>({});

  #flowService = inject(FlowService);

  ngOnInit(): void {
    if (!this.field.model?.length && !this.props.noAddByDefault) {
      this.add();
    }

    if (this.props?.gridView && this.props?.cols) {
      this.containerStyles.set({
        '--cols': this.props.cols,
      });
    }
  }

  override add(): void {
    super.add();

    if (this.props.onAdd && typeof this.props.onAdd === 'function') {
      // Call the onAdd function
      this.props.onAdd(this.field, this.formControl);
    }
  }

  override remove(index: number): void {
    if (this.props.onRemove && typeof this.props.onRemove === 'function') {
      // Call the onRemove function
      this.props.onRemove(this.field, this.formControl, index);
    }

    super.remove(index);
  }

  drop(event: CdkDragDrop<NodeDataParameters[]>): void {
    if (event.previousIndex === event.currentIndex) {
      return;
    }

    const formValue = [...(this.formControl.getRawValue() as NodeDataParameters[])];

    moveItemInArray(formValue, event.previousIndex, event.currentIndex);
    this.formControl.patchValue(formValue);
    this.formControl.markAllAsTouched();
  }
}
